import { useState } from "react";
import { Globe2 } from "lucide-react";
import { cn } from "@shared/lib/utils";

/**
 * Le favicon du site d'une offre.
 *
 * Une offre se reconnaît à son site : son icône vaut mieux qu'un globe
 * générique dès qu'un compte en surveille plusieurs. L'image passe par
 * `/api/favicon` (notre serveur, pas un service d'icônes tiers) et retombe
 * silencieusement sur le globe si le site n'en publie pas d'exploitable.
 */
export function OfferFavicon({ url, size = 20, className }: {
  url: string | null;
  size?: number;
  className?: string;
}) {
  const [failed, setFailed] = useState(false);

  if (!url || failed) {
    return (
      <Globe2
        aria-hidden="true"
        className={cn("shrink-0 text-muted-foreground", className)}
        style={{ width: size, height: size }}
      />
    );
  }

  return (
    <img
      alt=""
      className={cn("shrink-0 rounded-[4px] object-contain", className)}
      height={size}
      onError={() => setFailed(true)}
      src={`/api/favicon?url=${encodeURIComponent(url)}`}
      width={size}
    />
  );
}
